import React, { useCallback, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import { isValidPassword } from 'utils/utils'

import Presneter from 'components/presenters/signup/SignupPasswordScene'
import ScenePaginationFooter from 'components/presenters/footer/ScenePaginationFooter'

export default function PasswordFormScene({
  initPassword,
  currSceneNum,
  totalSceneNum,
  onComplete,
  onError,
}) {
  const [password, setPassword] = useState('')
  const [passwordError, setPasswordError] = useState(null)
  const [confirmPassword, setConfirmPassword] = useState('')
  const [confirmPasswordError, setConfirmPasswordError] = useState(null)

  const [isValid, setIsValid] = useState(false)

  const checkConfirmPasswordValid = useCallback(
    (value) => {
      return password === value
    },
    [password],
  )

  const checkValid = useMemo(() => {
    if (
      password.length === 0 ||
      !isValidPassword(password) ||
      confirmPassword.length === 0 ||
      !checkConfirmPasswordValid(confirmPassword)
    ) {
      return false
    }
    return true
  }, [checkConfirmPasswordValid, confirmPassword, password])

  const handleConfirmPasswordChange = (e) => {
    const confirmPasswordValue = e.target.value
    if (checkConfirmPasswordValid(confirmPasswordValue) || confirmPasswordValue.length === 0) {
      setConfirmPasswordError(null)
    } else {
      setConfirmPasswordError('비밀번호가 일치하지 않아요')
    }
    setConfirmPassword(confirmPasswordValue)
  }

  const handlePasswordChange = (e) => {
    const passwordValue = e.target.value
    if (isValidPassword(passwordValue) || passwordValue.length === 0) {
      setPasswordError(null)
    } else {
      setPasswordError('비밀번호는 영문, 숫자, 특수문자 포함 8자 이상으로 설정해 주세요')
    }
    setPassword(passwordValue)
  }

  const handleNextScene = () => {
    if (onComplete && isValid) {
      onComplete(password)
    }
  }

  useEffect(() => {
    setIsValid(checkValid)
  }, [password, confirmPassword, checkValid])

  useEffect(() => {
    if (initPassword) {
      setPassword(initPassword)
      setConfirmPassword(initPassword)
    }
  }, [initPassword])

  return (
    <PasswordFormWrapper>
      <Presneter
        password={password}
        setPassword={setPassword}
        passwordError={passwordError}
        handleChangePassword={handlePasswordChange}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        handleChangeConfirmPassword={handleConfirmPasswordChange}
        confirmPasswordError={confirmPasswordError}
      />
      <ScenePaginationFooter
        totalSceneNum={totalSceneNum}
        currSceneNum={currSceneNum}
        valid={isValid}
        onComplete={handleNextScene}
      />
    </PasswordFormWrapper>
  )
}

const PasswordFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
